import { render, staticRenderFns } from "./RegimenFiscal.vue?vue&type=template&id=b1d1e87c&scoped=true"
import script from "./RegimenFiscal.vue?vue&type=script&lang=js"
export * from "./RegimenFiscal.vue?vue&type=script&lang=js"
import style0 from "./RegimenFiscal.vue?vue&type=style&index=0&id=b1d1e87c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d1e87c",
  null
  
)

export default component.exports